module.exports = __webpack_public_path__ + "img/aer-pampa.3cfd2b2d.jpg";